/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pronunciation_Report_Passage_AttachedInputs */

const en_pronunciation_report_passage_attached = /** @type {(inputs: Pronunciation_Report_Passage_AttachedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passage attached to your report`)
};

const es_pronunciation_report_passage_attached = /** @type {(inputs: Pronunciation_Report_Passage_AttachedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pasaje adjunto a tu reporte`)
};

/**
* | output |
* | --- |
* | "Passage attached to your report" |
*
* @param {Pronunciation_Report_Passage_AttachedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const pronunciation_report_passage_attached = /** @type {((inputs?: Pronunciation_Report_Passage_AttachedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pronunciation_Report_Passage_AttachedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_pronunciation_report_passage_attached(inputs)
	return en_pronunciation_report_passage_attached(inputs)
});